import axios from '@axios'

const route = 'configuration/professional_activity'

export default {
  namespaced: true,
  state: {
    config: {},
  },
  getters: {
    getAll: state => state.config,
    config: state => state.config,
  },
  mutations: {
    SET_CONFIG(state, data) {
      state.config = data || {}
    },
  },
  actions: {
    fetchConfig({ commit }) {
      return axios.get(route).then(response => {
        commit('SET_CONFIG', response.data)
        return response
      })
    },

    getAll({ commit }) {
      return axios.get(route).then(response => {
        commit('SET_CONFIG', response.data)
        return response
      })
    },

    updateOrCreate({ commit, dispatch }, data) {
      return axios.post(route, data).then(response => {
        dispatch('fetchConfig')
        return response
      })
    },
  },
}
